<template>
  <a v-translate
     :class="interestedBtnClasses"
     :disabled="loading || interested"
     @click.stop="handleInterestedBtnClick()">
    I'm interested
  </a>
</template>

<script>
export default {
  props: {
    recommendedJobId: String,
    interested: Boolean
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    interestedBtnClasses() {
      return [
        'button button-interested',
        {'is-primary-ghost-small': !this.interested && !this.loading},
        {'is-mid-gray is-rounded  small': this.interested || this.loading},
        {'is-loading': this.loading}
      ];
    }
  },
  methods: {
    toogleLoading() {
      this.loading = !this.loading;
    },
    handleInterestedBtnClick() {
      this.toogleLoading();
      this.$store.dispatch('interestedRecommendedJobAction', this.recommendedJobId).then(() => this.toogleLoading());
    }
  }
};
</script>

<style lang="scss" scoped>
.button-dismiss {
  min-width: 100px;
}
</style>
